import React from 'react'
import Articles from '../Articles'
import { getProps } from './getProps'

export default (props) => <Articles {...getProps(props)}/>
